import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import intlShape from '@/shared/utils/intlShape';
import Checkbox from '@/shared/components/input/Checkbox';

const messages = defineMessages({
  ExportFiscalSections: 'Export fiscal sections',
  FiscalReportInfo: 'Select the fiscal sections you want to export:',
  FiscalCosts: 'Fiscal costs',
  FiscalLoans: 'Fiscal loans',
  FiscalVehicles: 'Fiscal vehicles',
  FiscalInsurances: 'Fiscal insurances',
  FiscalRealEstates: 'Fiscal real estates',
});

const fiscalSections = [
  {
    message: messages.FiscalVehicles,
    key: 'vehicle',
  },
  {
    message: messages.FiscalLoans,
    key: 'loan',
  },
  {
    message: messages.FiscalCosts,
    key: 'cost',
  },
  {
    message: messages.FiscalInsurances,
    key: 'insurance',
  },
  {
    message: messages.FiscalRealEstates,
    key: 'realEstate',
  },
];

export default class FiscalReportModal extends Component {
  state = {
    value: {
      cost: true,
      loan: true,
      vehicle: true,
      insurance: true,
      realEstate: true,
    },
  };
  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  isFormInvalid = () => {
    const { value } = this.state;
    const { cost, loan, vehicle, insurance, realEstate } = value;
    // At least 1
    if (!cost && !loan && !vehicle && !insurance && !realEstate) return true;

    return false;
  };

  setValue = (name, checked) => {
    if (!name) return;
    this.setState(({ value }) => ({ value: { ...value, [name]: !!checked } }));
  };

  onSave = () => {
    const { value } = this.state;

    const { onSave } = this.props;
    return onSave(value);
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { value } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ExportFiscalSections)}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <p>
          <FormattedMessage {...messages.FiscalReportInfo} />
        </p>
        <div className="form-horizontal">
          {fiscalSections.map(({ key, message }) => (
            <div className="form-group" key={key}>
              <Checkbox
                extraClass="col-sm-offset-1 col-md-11"
                id={key}
                name={key}
                value={value[key]}
                onClick={c => this.setValue(key, c)}
                text={intl.formatMessage(message)}
              />
            </div>
          ))}
        </div>
      </OkCancelModal>
    );
  }
}
